module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABwAAAAcCAYAAAByDd+UAAAAAXNSR0IArs4c6QAAAS1JREFUSEvtljFKBEEQRd/PDcRAPIAYCIK5iWaCsR7CUAXT3Vxz9QhqrKFrIngGU/EaXxpmYXbG6Z4eewcEO+6qV1W/qigx8tPIPFpA26fAeiSQd0nPQwNdANo+B64Szp4kHZUCvgD7CWdTSZPSwJmkg6FOY3bNks4z/Ae2qmY76Pol6W7pJbUdGi3IEV60qYpoaHsFeAN2UtAiwACxvQE8AnsVdCJp2ixvFtD2dmILBf+XwGFXpr2BtjeBjwGzuaBpDrDeGDnca0kXc4PewEqnXWA1QQvL/7j68yDppP4/C5hKy/Z9DBbsiwH7wIoBG4PfKmPxktpeA26AT0lnS19tKW2LZ/g3gZGoX0ueGPU56mL+6hr46Uy8BbYiGYbdOMvRrbNphjrJsRv98v4GyfW1HeflBqoAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/img/head-view/logout.png
// module id = Nc0C
// module chunks = 16